// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "icons-511ad.firebaseapp.com",
  "projectId": "icons-511ad",
  "storageBucket": "icons-511ad.appspot.com",
  "messagingSenderId": "541155032427",
  "appId": "1:541155032427:web:283d973528242e7e73602e",
  "measurementId": "G-BHQSVT3RGZ",
  "apiKey": "AIzaSyDq8tYsPEBXGHkSkE9xCSmSRC6quWrdT9c"
};
